import { z } from "zod";

/** The highest limit the backend accepts (VmReinstallSettings.MaxLimit); the lowest is 0. */
export const VM_REINSTALL_MAX_LIMIT = 1000;

/**
 * A limit as the operator types it. Kept as text and checked as a whole number: a coerced number
 * would read an emptied field as 0, and 0 is a limit an operator can really mean.
 */
function limitField(label: string) {
  return z
    .string()
    .trim()
    .regex(/^\d+$/, `${label} must be a whole number, 0 or more`)
    .refine(
      (value) => Number(value) <= VM_REINSTALL_MAX_LIMIT,
      `${label} must be ${VM_REINSTALL_MAX_LIMIT} or less`,
    );
}

export const vmSettingsSchema = z.object({
  reinstallLimitEnabled: z.boolean(),
  reinstallTrialLimit: limitField("The trial limit"),
  reinstallPaidLimitPerMonth: limitField("The monthly limit"),
});

export type VmSettingsFormData = z.infer<typeof vmSettingsSchema>;
